import React from "react";
import { Typography, Button, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Fullscreen from "@material-ui/icons/Fullscreen";
import FullscreenExit from "@material-ui/icons/FullscreenExit";
import { useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyle = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: theme.spacing(2),
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexGrow: 1,
  },
  title: {
    fontSize: "1.2rem",
    fontWeight: "bold",
    color: "white",
  },
  btn: {
    color: "#fff",
  },
}));

export default function TopBar({
  setOpen,
  dataCarga,
  isLoadPage,
  urlSacOnline,
  setModalUsuarios,
}) {
  const classes = useStyle();

  const [isFullScreen, setIsFullScreen] = useState(false);

  function toggleFullScreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullScreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullScreen(false);
      }
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.titleWrapper}>
        {/* <div
          className={classes.btn}
          onClick={() => {
            window.parent.postMessage(
              {},
              urlSacOnline // Coloque aqui o domínio do seu app React
            );
          }}
          style={{ cursor: "pointer" }}
        >
          <MenuIcon />
        </div> */}
        {/* <Button
          className={classes.btn}
          onClick={() => {
            window.parent.postMessage(
              {},
              "http://localhost:7000" // Coloque aqui o domínio do seu app React
            );
          }}
        >
          <MenuIcon />
        </Button> */}

        <Typography className={classes.title}>
          Cronograma - {dataCarga}
        </Typography>

        {isLoadPage && (
          <div
            className="lds-ring"
            style={{ marginTop: "-10px", marginLeft: "10px", color: "#FFF" }}
          >
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        )}
      </div>

      {false && (
        <React.Fragment>
          {/* <Tooltip title={"Tela Cheia"} arrow placement="right">
        <div> */}
          {!isFullScreen && (
            <Button className={classes.btn} onClick={() => toggleFullScreen()}>
              <Fullscreen />
            </Button>
          )}
          {/* </div>
      </Tooltip> */}

          {/* <Tooltip title={"Sair Tela Cheia"} arrow placement="right">
        <div> */}
          {isFullScreen && (
            <Button className={classes.btn} onClick={() => toggleFullScreen()}>
              <FullscreenExit />
            </Button>
          )}
          {/* </div>
      </Tooltip> */}
        </React.Fragment>
      )}

      <Button className={classes.btn} onClick={() => setModalUsuarios(true)}>
        <Tooltip
          title={"Alterar Visualização de Usuários"}
          arrow
          placement="right"
        >
          <SettingsIcon />
        </Tooltip>
      </Button>
    </div>
  );
}
